import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';
import './CustomError.css';
import { CustomErrorType } from './types/CustomErrorType';

/**
 * CustomError Component
 * A customizable error display component for showing validation errors, API failures, or global exceptions.
 */
export const CustomError: React.FC<CustomErrorType> = ({
    title = 'Something went wrong',
    message,
    onRetry,
    retryLabel = 'Try Again',
    variant = 'card',
    className = '',
}) => {
    return (
        <div className={`custom-error custom-error--${variant} ${className}`}>
            <AlertCircle size={variant === 'inline' || variant === 'toast' ? 20 : 48} className="custom-error__icon" />
            
            <div className="custom-error__content">
                <h3 className="custom-error__title">{title}</h3>
                <p className="custom-error__message">{message}</p>
            </div>

            {onRetry && (
                <button className="custom-error__retry-btn" onClick={onRetry}>
                    <RefreshCw size={14} style={{ marginRight: '8px' }} />
                    {retryLabel}
                </button>
            )}
        </div>
    );
};

export default CustomError;
